import { motion } from "framer-motion";
import { MaskedLine } from "./Reveal";

export const PageHero = ({ eyebrow, title, intro, image, testId }) => (
  <section className="relative isolate overflow-hidden pb-16 pt-36 sm:pb-24 sm:pt-44" data-testid={testId}>
    {image && (
      <div className="absolute inset-0 -z-10">
        <img
          src={image}
          alt=""
          className="h-full w-full object-cover opacity-25"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-ink/80 via-ink/70 to-ink" />
        <div className="absolute inset-0 bg-[radial-gradient(700px_circle_at_20%_20%,rgba(220,38,38,0.14),transparent_60%)]" />
      </div>
    )}
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <motion.p
        initial={{ opacity: 0, x: -16 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.7, delay: 0.15 }}
        className="font-mono text-xs font-bold uppercase tracking-[0.35em] text-kred"
      >
        {eyebrow}
      </motion.p>
      <h1 className="mt-5 font-display text-6xl uppercase leading-[0.9] tracking-tight text-bone sm:text-7xl lg:text-8xl">
        <MaskedLine delay={0.25}>{title}</MaskedLine>
      </h1>
      {intro && (
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="mt-7 max-w-2xl text-base leading-relaxed text-slate-400 sm:text-lg"
        >
          {intro}
        </motion.p>
      )}
      <motion.div
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 1, delay: 0.7 }}
        className="gold-rule mt-10 w-32 origin-left"
      />
    </div>
  </section>
);
